import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { ArrowLeft } from "lucide-react";
import api, { errMsg } from "../lib/api";

export default function ForgotPassword() {
  const [step, setStep] = useState("request");
  const [loginId, setLoginId] = useState("");
  const [token, setToken] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const request = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { loginId });
      toast.success("If the account exists, a reset code has been emailed.");
      setStep("reset");
    } catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
  };

  const reset = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, newPassword });
      toast.success("Password reset. Please login.");
      window.location.href = "/login";
    } catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-100 p-6">
      <div className="w-full max-w-md card p-8">
        <Link to="/login" className="text-sm text-slate-500 flex items-center gap-1 mb-4"><ArrowLeft className="h-4 w-4" /> Back to login</Link>
        <h2 className="font-head text-2xl font-bold text-slate-900 mb-6">Reset Password</h2>
        {step === "request" ? (
          <form onSubmit={request} data-testid="forgot-request-form">
            <label className="label">Login ID / Email</label>
            <input className="input mb-6" value={loginId} onChange={(e) => setLoginId(e.target.value)} required data-testid="forgot-loginid-input" />
            <button className="btn-primary w-full" disabled={busy}>{busy ? "Generating…" : "Send reset token"}</button>
          </form>
        ) : (
          <form onSubmit={reset} data-testid="reset-form">
            <p className="text-sm text-slate-500 mb-4">Enter the reset code sent to your registered email and choose a new password.</p>
            <label className="label">Reset Token</label>
            <input className="input mb-4" value={token} onChange={(e) => setToken(e.target.value)} required data-testid="reset-token-input" />
            <label className="label">New Password</label>
            <input className="input mb-6" type="password" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} required data-testid="reset-newpassword-input" />
            <button className="btn-primary w-full" disabled={busy}>{busy ? "Resetting…" : "Reset password"}</button>
          </form>
        )}
      </div>
    </div>
  );
}
